//import $ from 'jquery';
//import 'jquery-validation';

export const enMessages = {
    alphanumeric: "Letters, numbers, and underscores only please",
    alphanumericRestricted: "Letters, numbers, and underscores only please",
    reviewrange: "Please give us a score",
    phoneNumber: "Please enter a valid Phone Number",
    noSpace: "Please remove any whitespace",
    passwordCheck: "Password does not meet requirements. Please use at least one upper-case character, one lower-case character, and one number."
} as const;